import type { FaireProductEntity } from "../../entity_types/product";

export const p_77qhmr427g: FaireProductEntity = {
  token: "p_77qhmr427g",
  type: "product",
  name: "Bluegrass Soy Sauce",
  brandToken: "b_c5ws2rc6",
  brandName: "Bourbon Barrel Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/75cba3dce887f74ac3c4071c4a036c1ac63834ac4fed69debda1cb8d2c73175c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca0380f6660aed2f14b24b2b40c285618a1577778f83dc3641b17df5ee2418f8.png",
    "https://cdn.faire.com/fastly/e59de6d70d88450e5ec265701b1e5a694d7db3604bc47a580bb1d85de612474d.png",
    "https://cdn.faire.com/fastly/734e7c51f315068576f0315430be6d9aa9ad49625308951daa07dae6424a0d24.png",
    "https://cdn.faire.com/fastly/551e6ff07a19894b53b86c1f8e6fa972150bf1ab1dfaf07219db578b091e4f64.jpeg",
  ],
  priceDollars: 4.95,
  description:
    "This sauce is from the only small batch soy sauce brewery in the United States. It’s made from whole non-GMO Kentucky grown soybeans and pure limestone filtered Kentucky spring water.  It’s brewed and aged in bourbon barrels.  The result is a smoky, brothy sauce with hints of oak and a mild sweetness reminiscent of fine Kentucky bourbon. ",
  tags: [],
  msrpDollars: 9.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:11.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
